export const reducer = (
  state: any,
  action: { type: string; from?: string }
) => {
  switch (action.type) {
    case 'showThemeModal':
      return { ...state, themeModalStatus: 'show', from: action.from }
    case 'hideThemeModal':
      return { ...state, themeModalStatus: 'hide' }
    case 'updateUnread':
      return { ...state, updateUnread: state.updateUnread + 1 }
    default:
      return state
  }
}
